function makeAStar(centerx, centery, steps=5, outerr=22, innerr=11) {
    let n = 0;//a counter
    let c = {x:centerx,y:centery};//the center of the svg canvas
    let step = Math.PI/steps;//since the star has 5 points you will need to calculate the position of a point every 36degs i.e Math.PI/5;
    let path = ""

//a for loop to calculate the position of the points for the star
    for(let a=-Math.PI/2;  a<3*Math.PI/2; a+= step){
        //The point will be either on the outer circle (r=22) or on the inner one (r=11)
        let r = n%2 == 0 ? outerr : innerr;
        //calculate the x and y of the point
        let x = c.x + r*Math.cos(a);
        let y = c.y + r*Math.sin(a);
        //push the x and the y values to the pts array

        if (!path) {
            path += `M ${x} ${y}`
        } else {
            path += ` L ${x} ${y}`
        }
        //increase the counter
        n++
    }

    return path;
}


export class DateProgressElement extends HTMLElement {
    static observedAttributes = ["begin", "end", "text"]

    constructor() {
        // Always call super first in constructor
        super();
        console.log("ziege-progress constructed")
    }

    connectedCallback() {
        const shadowE = this.attachShadow({ mode: "open" });
        const wrapperE = document.createElement("div")

        const progressE = document.createElement("div")
        const progressBgE = document.createElement("div")


        const explainE = document.createElement("div")

        shadowE.appendChild(wrapperE)
        wrapperE.appendChild(progressBgE)
        wrapperE.appendChild(progressE)
        wrapperE.appendChild(explainE)

        wrapperE.style.position = "relative";
        wrapperE.style.width = "100%";
        wrapperE.style.paddingTop = "5px";

        progressE.style.backgroundColor = "var(--z-progress-done)"
        progressE.style.position = "absolute";
        progressE.style.height = "5px"
        progressE.style.left = "0";
        progressE.style.right = "0";
        progressE.style.top = "0";

        progressBgE.style.position = "absolute";
        progressBgE.style.left = "0";
        progressBgE.style.right = "0";
        progressBgE.style.top = "0";
        progressBgE.style.height = "5px";
        progressBgE.style.backgroundColor = "var(--z-track)";

        explainE.style.textAlign = "center"
        explainE.style.color = "var(--z-text)"
        explainE.style.fontSize = "0.8rem"
        explainE.style.padding = "0.2rem";


        this.beginDate = this.getAttribute("begin")
        this.endDate = this.getAttribute("end")

        this.explainText = this.getAttribute("text")
        explainE.innerText = this.explainText


        this.updateProgress = () => {
            const dtBegin = new Date(parseInt(this.beginDate))
            const dtEnd = new Date(parseInt(this.endDate))
            const dtNow = new Date()

            let progress = ((dtNow - dtBegin) / (dtEnd - dtBegin)) * 100
            progress = Math.min(progress, 100)
            progressE.style.width = `${progress}%`
            explainE.innerText = this.explainText
        }
        this.updateProgress()

        this.intervalId = window.setInterval(this.updateProgress, 3600 * 1000);
    }

    disconnectedCallback() {
        if (this.intervalId) {
            window.clearInterval(this.interval);
        }
    }



    attributeChangedCallback(name, oldValue, newValue) {
        console.log("attribute change on date progress")
        if (name === "begin") {
            this.beginDate = newValue;
            window.setTimeout(this.updateProgress)
        } else if (name === "end") {
            this.endDate = newValue;
            window.setTimeout(this.updateProgress)
        } else if (name === "text") {
            this.explainText = newValue;
            window.setTimeout(this.updateProgress)
        }
    }

}

// Ziegenspur: ein grüner Weg mit einem Feld je nötiger Erledigung im Zeitraum und einem
// Ziel. Erledigungen füllen ihn Feld für Feld, auf der zurückgelegten Strecke liegen
// Hufabdrücke. Ist der Zeitraum voll, steht am Ziel ein goldener Stern.
//
// Attribute: max (Erledigungen im Zeitraum), value (davon geschafft), muted (kein Ton).
// Steigt value, läuft die Füllung in ANIMATION_MS zum neuen Stand, und es klingt ein
// Ton; beim Erreichen von max ein anderer.

const SVG_NS = "http://www.w3.org/2000/svg";
const R = 10;
const CY = 16;
const LENGTH = 200;
const ANIMATION_MS = 700;
let clipCounter = 0;

function svgEl(name, attrs, parent, style = {}) {
    const e = document.createElementNS(SVG_NS, name);
    for (const [k, v] of Object.entries(attrs)) {
        e.setAttribute(k, v);
    }
    Object.assign(e.style, style);
    if (parent) {
        parent.appendChild(e);
    }
    return e;
}

function easeInOut(t) {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
}

const STYLE = `
:host { display: block; }
svg { width: 100%; height: auto; display: block; overflow: visible; }
.pop { animation: pop .6s cubic-bezier(.2, 1.6, .4, 1); transform-box: fill-box; transform-origin: center; }
@keyframes pop { 0% { transform: scale(0); } 100% { transform: scale(1); } }
.spark { animation: spark .8s ease-out forwards; }
@keyframes spark { 0% { opacity: 1; transform: translate(0, 0); } 100% { opacity: 0; transform: translate(var(--dx), var(--dy)); } }
@media (prefers-reduced-motion: reduce) { .pop, .spark { animation: none; } }
`;

export class ZiegeProgressElement extends HTMLElement {
    static observedAttributes = ["value", "max"];

    connectedCallback() {
        if (!this.shadowRoot) {
            this.attachShadow({mode: "open"});
            const style = document.createElement("style");
            style.textContent = STYLE;
            this.shadowRoot.appendChild(style);
            this.progressAudio = new Audio("static/progress.wav");
            this.completionAudio = new Audio("static/completion.wav");
        }
        // Elm setzt die Attribute, bevor das Element eingehängt ist; ab hier gelten sie.
        this.shown = this.current();
        this.render(this.shown, false);
    }

    disconnectedCallback() {
        cancelAnimationFrame(this.frame);
    }

    maxValue() {
        return Math.max(1, parseInt(this.getAttribute("max")) || 1);
    }

    current() {
        return Math.max(0, Math.min(parseInt(this.getAttribute("value")) || 0, this.maxValue()));
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.shadowRoot || oldValue === newValue) {
            return;
        }
        const target = this.current();
        if (name === "max") {
            this.shown = target;
            this.render(target, false);
            return;
        }
        const from = this.shown ?? target;
        if (target > from && !this.hasAttribute("muted")) {
            (target === this.maxValue() ? this.completionAudio : this.progressAudio).play().catch(() => {});
        }
        this.animateTo(from, target);
    }

    animateTo(from, to) {
        cancelAnimationFrame(this.frame);
        const celebrate = to === this.maxValue() && to > from;
        this.shown = to;
        if (from === to || matchMedia("(prefers-reduced-motion: reduce)").matches) {
            this.render(to, celebrate);
            return;
        }
        const start = performance.now();
        const step = (now) => {
            const t = Math.min(1, (now - start) / ANIMATION_MS);
            if (t < 1) {
                this.render(from + (to - from) * easeInOut(t), false);
                this.frame = requestAnimationFrame(step);
            } else {
                this.render(to, celebrate);
            }
        };
        this.frame = requestAnimationFrame(step);
    }

    // p: geschaffter Anteil in Feldern, während der Animation auch dazwischen.
    render(p, celebrate) {
        const max = this.maxValue();
        const stepWidth = (LENGTH - 2 * R) / max;
        const xs = Array.from({length: max + 1}, (_, k) => R + k * stepWidth);
        const goalX = xs[max];
        const front = xs[0] + p * stepWidth;

        const svg = svgEl("svg", {viewBox: `-6 0 ${LENGTH + 12} 32`, role: "img", "aria-label": `${Math.round(p)} von ${max} erledigt`});
        const clipId = `ziegenspur-${++clipCounter}`;
        const clip = svgEl("clipPath", {id: clipId}, svgEl("defs", {}, svg));
        svgEl("rect", {x: -6, y: 0, width: front + R + 6, height: 32}, clip);

        const outline = svgEl("g", {"stroke-width": 2}, svg, {stroke: "var(--z-path)", fill: "none"});
        svgEl("line", {x1: xs[0] + R, y1: CY - R / 2, x2: goalX - R, y2: CY - R / 2}, outline);
        svgEl("line", {x1: xs[0] + R, y1: CY + R / 2, x2: goalX - R, y2: CY + R / 2}, outline);
        xs.forEach((x) => svgEl("circle", {cx: x, cy: CY, r: R}, outline, {fill: "var(--z-surface)"}));

        const fill = svgEl("g", {"clip-path": `url(#${clipId})`}, svg, {fill: "var(--z-path)"});
        svgEl("rect", {x: xs[0], y: CY - R / 2, width: goalX - xs[0], height: R}, fill);
        xs.forEach((x) => svgEl("circle", {cx: x, cy: CY, r: R}, fill));

        // Paarige Hufabdrücke in Laufrichtung, abwechselnd links und rechts; einer taucht
        // auf, sobald die Füllung an ihm vorbei ist.
        let n = 0;
        for (let x = xs[0] + 7; x < goalX - R - 1; x += 6.5, n++) {
            const opacity = Math.max(0, Math.min(1, (front - (x + 3)) / 10));
            if (opacity <= 0) {
                break;
            }
            const print = svgEl("g", {transform: `translate(${x} ${CY + (n % 2 ? -1.7 : 1.7)})`, opacity}, svg, {fill: "var(--z-path-print)"});
            svgEl("path", {d: "M-1.5 -0.35 C -1.6 -1.6 0.4 -1.9 1.8 -0.9 C 1 -0.45 -0.4 -0.3 -1.5 -0.35 Z"}, print);
            svgEl("path", {d: "M-1.5 0.35 C -1.6 1.6 0.4 1.9 1.8 0.9 C 1 0.45 -0.4 0.3 -1.5 0.35 Z"}, print);
        }

        if (p >= max) {
            const goal = svgEl("g", {}, svg);
            svgEl("circle", {cx: goalX, cy: CY, r: 14, "stroke-width": 2.5}, goal, {fill: "var(--z-surface)", stroke: "var(--z-path)"});
            svgEl("path", {d: makeAStar(goalX, CY, 5, 9, 4), "stroke-width": 0.8, "stroke-linejoin": "round"}, goal, {fill: "var(--z-reward)", stroke: "var(--z-reward-ink)"});
            if (celebrate) {
                goal.classList.add("pop");
                for (let i = 0; i < 10; i++) {
                    const angle = (i / 10) * Math.PI * 2;
                    const spark = svgEl("circle", {cx: goalX, cy: CY, r: 1.6}, svg, {fill: i % 2 ? "var(--z-reward)" : "var(--z-path)"});
                    spark.style.setProperty("--dx", `${Math.cos(angle) * 22}px`);
                    spark.style.setProperty("--dy", `${Math.sin(angle) * 22}px`);
                    spark.classList.add("spark");
                }
            }
        } else {
            svgEl("path", {d: makeAStar(goalX, CY, 5, 6, 2.7), "stroke-width": 1.2, "stroke-linejoin": "round", opacity: 0.6}, svg, {fill: "none", stroke: "var(--z-path)"});
        }

        this.shadowRoot.querySelector("svg")?.remove();
        this.shadowRoot.appendChild(svg);
    }
}
